export const createSelectValueList = (itemList) => {
    return itemList.map(item => ({
        id: item,
        value: item,
    }))
}

export const getSelectValue = (itemList, _id) => {
    if (!itemList) {
        return ''
    }
    const item = itemList.find(({id}) => id === _id)

    return item ? item.value : ''
}


// WEBPACK FOOTER //
// ./src/util/select.js